import styled from 'styled-components';

const TextArea = styled.textarea<{ isReadOnly?: boolean }>`
  background: var(--color-bg-primary);
  resize: none;

  width: 100%;
  border: 1px solid var(--color-border-primary);
  box-sizing: border-box;
  border-radius: 10px;
  letter-spacing: -0.0024em;
  padding: 6px 12px;
  min-height: 100px;

  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  color: var(--color-text-primary);

  &::placeholder {
    color: var(--color-text-muted);
  }

  box-shadow: var(--shadow-sm);

  &:focus {
    border: ${(props) =>
      props.isReadOnly ? 'unset' : '1px solid var(--color-info-v2)'};

    box-shadow: ${(props) =>
      props.isReadOnly ? 'unset' : '0px 0px 0px 2px rgba(93, 138, 255, 0.25)'};
  }

  &:focus-within {
    outline: unset;
  }

  ${(props) =>
    props.isReadOnly &&
    `
    resize: none;
    cursor: not-allowed !important;
  `}
`;

export default TextArea;
